import { IdentificationSearchSchema } from '@/features/dashboard/client/identification-list/identificationListSchema';
import { IdentificationList } from '@/features/dashboard/client/identification-list/list/IdentificationList'
import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/identifications/')({
  component: RouteComponent,
  validateSearch: (search) => {
    // IdentificationSearchSchemaのデフォルト値が自動的に適用される
    return IdentificationSearchSchema.parse(search);
  }
})

function RouteComponent() {
  usePageTitle("本人確認一覧");
  return <IdentificationList />
}
